import React from "react";

const LiquidContainer = ({ children, backgroundColor, radius, ancho, alto, borderline, boxSdw }) => {
  return (
    <div className="liquidContainer d-flex justify-content-center align-items-center m-0 p-0"
      style={{
        width: ancho || '100%',
        height: alto || 'auto',
        backgroundColor: backgroundColor || 'rgba(245, 253, 255, 0.69)', // fallback color
        borderRadius: radius || '25px',
        boxShadow: boxSdw ||'0 2px 8px #16181995',
        border: borderline ||'1px solid black',
        zIndex: 1,
        overflowY: 'scroll',
        overflowX: 'hidden',
      }}
    >
      {children}
    </div>
  );
};

export default LiquidContainer;
